module.exports = __webpack_public_path__ + "img/12.a892f0f3.jpg";